import $ from "jquery";
import jBox from "jbox";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ModalConfirmExchange = ({
  point = 0,
  isOpen = false,
  onClose = () => {},
  onConfirm = () => {},
}) => {
  const [modalRef, setModalRef] = useState(null);
  const [confirm, setConfirm] = useState(false);

  useEffect(() => {
    if (modalRef && isOpen) {
      openModal();
      listenerConfirmModal();
      listenerCloseModal();
    }
  }, [modalRef, isOpen]);

  useEffect(() => {
    const initModalRef = new jBox("Modal", {
      closeButton: false,
      closeOnClick: false,
      minWidth: 325,
      maxWidth: 375,
      content: $("#ModalConfirmExchange"),
    });
    setModalRef(initModalRef);

    return () => {
      initModalRef.destroy();
    };
  }, []);

  const listenerConfirmModal = () => {
    const btnCloseModal = document.getElementById("btnCloseModal0CF");
    btnCloseModal.addEventListener("click", () => {
      // onConfirm();
      // closeModal(); // ระวังบางหน้าไม่มี
      setConfirm(true);
    });
  };

  useEffect(() => {
    if (confirm) {
      onConfirm(confirm);
    }
  }, [confirm]);

  const listenerCloseModal = () => {
    const btnCloseModal = document.getElementById("btnCloseModal0C");
    btnCloseModal.addEventListener("click", () => {
      closeModal();
    });
  };

  const openModal = () => {
    modalRef.open();
  };

  const closeModal = () => {
    modalRef.close();
    onClose();
  };

  return (
    <div
      className="bModal bCard"
      id="ModalConfirmExchange"
      style={{ display: "none" }}
    >
      <div className="bInner">
        <div className="bDetails">
          <p className="tTitle">คุณยืนยันแลกรางวัล</p>
          <p className="tDetails">
            คุณต้องการใช้ {point} point
            <br /> แลกของรางวัลกับเรา?
          </p>
        </div>
        <div className="bBtn">
          <a className="btn" id="btnCloseModal0CF">
            ยืนยัน
          </a>
          <a className="btn outline btnModalCancel" id="btnCloseModal0C">
            ยกเลิก
          </a>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmExchange;
